import { HTTP } from './helpers/http.js'

export default {
  generatePowerPoint(organizationId, revId, revType, layout) {
    const url = `/api/v1/organizations/${organizationId}/powerpoint-download`

    return HTTP.post(
      url,
      {
        revId,
        revType,
        layout,
      },
      {
        responseType: 'arraybuffer',
      }
    )
  },
}
